import React, { useState, useEffect, useContext } from "react";
import { Paper, Typography, Box, List, CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { fetchUserBookmarks } from "gatsby-frontend";
import { SiteContext } from "gatsby-frontend/src/Site";
import Excerpt from "./site/Excerpt";

export default function BookmarkList() {
	const theme = useTheme();
	const { dispatch, isAuthenticated, userData } = useContext(SiteContext);

	const [bookmarks, setBookmarks] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);

	useEffect(() => {
		getBookmarks();
	}, [userData]);

	const getBookmarks = async () => {
		let _dispatch = isAuthenticated ? dispatch : null;
		if (_dispatch && userData) {
			setLoading(true);
			setError(false);
			let result = await fetchUserBookmarks(_dispatch, userData);
			if (result !== false) {
				setBookmarks(result);
			} else {
				setError(true);
				setBookmarks([]);
			}
			setLoading(false);
		}
	};

	return (
		<Paper
			elevation={3}
			sx={{
				padding: theme.spacing(3, 4),
			}}
		>
			<Typography
				variant="h4"
				sx={(theme) => ({ marginBottom: theme.spacing(2) })}
			>
				My Bookmarks
			</Typography>

			{error && (
				<Box style={{ textAlign: "center" }}>
					<p>There was an error getting the bookmarks</p>
				</Box>
			)}

			{loading ? (
				<Box style={{ textAlign: "center" }}>
					<CircularProgress />
				</Box>
			) : (
				<>
					{bookmarks.length == 0 ? (
						<Box style={{ textAlign: "center" }}>
							<p>You don't have bookmarks yet</p>
						</Box>
					) : (
						<List>
							{bookmarks.map((item) => (
								<Box key={item.id}>
									<Excerpt {...item} mode="list" />
								</Box>
							))}
						</List>
					)}
				</>
			)}
		</Paper>
	);
}
